import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../../routes/slice';
import PreviewDividends from './Dividends/preview';
import PreviewInterest from './Interest/preview';
import PreviewPension from './Pension/preview';
import PreviewRentalIncome from './RentalIncome/preview';

export interface IPassiveIncomePreviewProps {}

export default function PassiveIncomePreview(
  props: IPassiveIncomePreviewProps,
) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <h1 className="w-full rounded-t-2xl bg-green text-white px-4  font-semibold pl-6 py-4 mt-8">
        Passive Income
      </h1>
      {/* <PreviewGeneralPassiveIncome /> */}
      {routes.income.passiveIncome.dividends && <PreviewDividends />}
      {routes.income.passiveIncome.interest && <PreviewInterest />}
      {routes.income.passiveIncome.pension && <PreviewPension />}
      {routes.income.passiveIncome.rentalIncome && <PreviewRentalIncome />}
    </>
  );
}
